import { METADATA } from '@ringcentral/rwc-utils/src/web-client-info';

const template = info => `
------------------------------------------------
App:
    Version: ${info.version}
    Brand: ${info.brand}
    Branch: ${info.branch}
    Commit: ${info.commit}
    BuildNumber: ${info.buildNumber}
------------------------------------------------
`;

// eslint-disable-next-line no-console
console.trace(template(METADATA));
